import { getToken } from './auth/get-token';
import { loadCart } from './cart/load-cart';
import { AuthErrorCodes } from '../../types';
export const useHelper = (dispatch, getState) => {
    function withAuth(fn) {
        const getRefreshedAuthToken = async () => {
            await dispatch(getToken());
            return getState().auth.token;
        };
        return async (...args) => {
            let authToken = getState().auth.token;
            if (!authToken)
                authToken = await getRefreshedAuthToken();
            try {
                return await fn(authToken, ...args);
            }
            catch (e) {
                if (e?.code === AuthErrorCodes.Unauthorized) {
                    authToken = await getRefreshedAuthToken();
                    if (authToken)
                        return fn(authToken, ...args);
                }
                throw e;
            }
        };
    }
    function withCart(fn) {
        return async (...args) => {
            let { cart } = getState();
            if (!cart.data.id) {
                await dispatch(loadCart());
                cart = getState().cart;
            }
            return fn(cart.data, ...args);
        };
    }
    return {
        withAuth,
        withCart,
    };
};
